module.exports = __webpack_public_path__ + "Scan@2x.2b47927c.png";


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/AttendanceScan/images/Scan@2x.png
// module id = MmVP
// module chunks = 0